export default {
  state: {
    compareActive: false,
    compareItems: [],
    maxCompareItems: 2,
    isCompareBannerSticky: false,
  },
  getters: {
    getCompareItems: (state) => state.compareItems,
    getCompareActiveState: (state) => state.compareActive,
    getMaxCompareItems: (state) => state.maxCompareItems,
    getIsCompareBannerSticky: (state) => state.isCompareBannerSticky,
    getIsCompareBannerActiveAndSticky: (state) => state.isCompareBannerSticky && state.compareActive,
  },
  mutations: {
    setComparingActive: (state, value) => {
      // eslint-disable-next-line no-param-reassign
      state.compareActive = value;
    },
    setMaxCompareItems: (state, value) => {
      // eslint-disable-next-line no-param-reassign
      state.maxCompareItems = value;
    },
    addItemToCompareList: (state, value) => {
      state.compareItems.push(value);
    },
    removeItemFromCompareList: (state, value) => {
      // eslint-disable-next-line no-param-reassign
      state.compareItems = state.compareItems.filter((item) => item.id !== value.id);
    },
    emptyCompareList: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.compareItems = [];
    },
    setIsCompareBannerSticky: (state, value) => {
      // eslint-disable-next-line no-param-reassign
      state.isCompareBannerSticky = value;
    },
  },
  actions: {
    addItemToCompareList: ({ commit }, payload) => {
      commit('addItemToCompareList', payload);
    },
    setMaxCompareItems: ({ commit }, amount) => {
      commit('setMaxCompareItems', amount);
    },
    toggleCompareItem: ({ commit, getters, dispatch }, item) => {
      const shouldAddItemToCompareList = item.isActive === true
      && getters.getCompareItems.length < getters.getMaxCompareItems
      && !getters.getCompareItems.includes(item);

      if (shouldAddItemToCompareList) {
        commit('addItemToCompareList', item);
      } else {
        commit('removeItemFromCompareList', item);
      }

      // Update query params
      const selectedCompareProductIds = getters.getCompareItems.map((product) => product.id);
      dispatch('setQueryParams', {
        ...getters.getQueryParams,
        compareProduct: selectedCompareProductIds,
        loadData: false,
      });
    },
    setComparingMode: ({ commit, dispatch }, value) => {
      commit('setComparingActive', value);

      if (value === true) {
        dispatch('fetchPrices');
      } else {
        commit('emptyCompareList');
      }
    },
    toggleComparingMode: async ({ commit, getters, dispatch }) => {
      const newCompareState = !getters.getCompareActiveState;
      commit('setComparingActive', newCompareState);

      if (newCompareState) {
        // Compare mode activated - update query params
        dispatch('setQueryParams', {
          ...getters.getQueryParams,
          compare: '1',
          loadData: false,
        });
      } else {
        // Compare mode deactivated - clear compare query params
        commit('emptyCompareList');
        dispatch('setQueryParams', {
          ...getters.getQueryParams,
          compare: [],
          compareProduct: [],
          loadData: false,
        });
      }
    },
    setIsCompareBannerSticky: ({ commit }, payload) => {
      commit('setIsCompareBannerSticky', payload);
    },
  },
};
